"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userPopupSchemaFields_1 = __importDefault(require("./userPopupSchemaFields"));
exports.default = (0, graphql_tag_1.default)`
  ${userPopupSchemaFields_1.default}
  fragment filterSchemaFields on FilterSchema {
    name
    type
    showDetailedInfo
    items {
      count
      value
      name
      user {
        ...userPopupSchemaFields
      }
      icon
      iconColor
      backgroundColor
      countColor
      isVisible
      description
    }
  }
`;